import script from "./tab-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-bar.vue?vue&type=script&setup=true&lang=js"

import "./tab-bar.vue?vue&type=style&index=0&id=4c8458dd&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c8458dd"]])

export default __exports__